import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import Icon from '../../../components/AppIcon';

// Fix for default markers in Leaflet
delete L?.Icon?.Default?.prototype?._getIconUrl;
L?.Icon?.Default?.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});

const MapContainer = ({ activeFilters, onMarkerClick, selectedMarker }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]);
  const trailLinesRef = useRef([]);
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  // Thematic trails data with GPS coordinates and static map URLs
  const thematicTrails = [
  // Montenegro Trails (Orange routes)
  {
    id: 1,
    name: "Od glečera do Grebaje",
    country: "montenegro",
    color: "#E67E22",
    staticMapUrl: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763462493/0_-_mapa_staze_1_GREBAJA.jpg_mini_kwttgv.jpg",
    coordinates: [
    [42.50969, 19.83356], // Dolina Ropojana
    [42.51251, 19.83481], // Oko Skakavice
    [42.52292, 19.84157], // Vodopad Grlja
    [42.55000, 19.82469], // Ali-pašini izvori
    [42.59839, 19.93081], // Plavsko jezero
    [42.57179, 20.03488], // Hridsko jezero
    [42.61561, 19.92584], // Botanička bašta Velemun
    [42.59565, 19.94600] // Kula Redžepagića
    ]
  },
  {
    id: 2,
    name: "Legende i priče iz srednjovjekovnog Brskova",
    country: "montenegro",
    color: "#E67E22",
    staticMapUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1730a3d49-1763463087171.png",
    coordinates: [
    [42.89965, 19.59747], // Planina Bjelasica
    [42.97256, 19.59948], // Spomenik na Bojnoj njivi
    [42.95386, 19.62821], // Medeno guvno
    [42.95660, 19.57739], // Spomenik Mojkovačke bitke
    [42.95668, 19.57667], // Stari most na Tari
    [43.03295, 19.74574], // Zavičajni muzej Bijelo Polje
    [42.96197, 19.72208], // Manastir Majstorovina
    [43.02630, 19.73995], // Manastir Nikoljac
    [43.03571, 19.74481], // Crkva Sv. Petra i Pavla
    [43.11427, 19.78496], // Manastir Voljavac
    [43.06987, 19.90246], // Manastir Podvrh
    [42.84406, 19.87258], // Polimski muzej Berane
    [42.87053, 19.87061], // Manastir Šudikova
    [42.85282, 19.86075] // Manastir Đurđevi stupovi
    ]
  },
  {
    id: 3,
    name: "Kanjon Tare - priče o ljudima i rijeci",
    country: "montenegro",
    color: "#E67E22",
    staticMapUrl: "https://images.unsplash.com/photo-1711308351903-6c4356373ccd",
    coordinates: [
    [43.12778, 19.31182], // Rijeka Tara (Kanjon)
    [42.98932, 19.41123], // Bistrica (pritoka)
    [43.13782, 19.30110], // Ljutica (pritoka)
    [43.01016, 19.41325], // Crna poda
    [43.01132, 19.37795], // Zabojsko jezero
    [43.02782, 19.40083], // Manastir Dobrilovina
    [43.12353, 19.34337], // Manastir Premćani
    [43.15685, 19.28556] // Manastir Đurđeviće Tara
    ]
  },
  {
    id: 4,
    name: "U zagrljaju šume i tri jezera",
    country: "montenegro",
    color: "#E67E22",
    staticMapUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_180525abc-1763463089352.png",
    coordinates: [
    [43.15745, 19.09268], // Barno jezero
    [43.15564, 19.07044], // Zminje jezero
    [43.14657, 19.09330], // Crno jezero
    [43.16308, 19.08721], // Selo Bosača
    [43.09473, 19.14952], // Srednjovjekovna groblja (stećci)
    [43.15126, 19.10301] // Prirodnjački muzej NP Durmitor
    ]
  },
  // Serbia Trails (Dark Green routes)
  {
    id: 5,
    name: "Život kroz vekove",
    country: "serbia",
    color: "#2E7D32",
    staticMapUrl: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763462228/1.1._-_Mapa_staze.jpg_mini_ab5qoj.jpg",
    coordinates: [
    [43.41444, 20.48444], // Restoran Beli Bagrem (Rudno)
    [43.41583, 20.48250], // Vila Jela
    [43.41722, 20.48750], // Orlovo gnezdo
    [43.43500, 20.42778] // Izvori reke Izubre
    ]
  },
  {
    id: 6,
    name: "Osluškujući damare srednjovekovne Srbije",
    country: "serbia",
    color: "#2E7D32",
    staticMapUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_158b9ee98-1763463088790.png",
    coordinates: [
    [43.48528, 20.53194], // Manastir Studenica
    [43.48833, 20.52806], // Restoran Studenica (Brezova)
    [43.51833, 20.45833], // Hotel Radočelo
    [43.14444, 20.50667], // Petrova crkva (Novi Pazar)
    [43.14889, 20.49639], // Manastir Đurđevi Stupovi
    [43.14083, 20.46639] // Manastir Sopoćani
    ]
  },
  {
    id: 7,
    name: "…I bi voda (Život ljudi u planini i vodi)",
    country: "serbia",
    color: "#2E7D32",
    staticMapUrl: "https://images.unsplash.com/photo-1730088644538-31aae34104b9",
    coordinates: [
    [43.40972, 20.45000], // Pansion Nebo (Srnjača)
    [43.41528, 20.48194], // Vila Selena (Rudno)
    [43.41667, 20.48667], // Domaćinstvo Šekler
    [43.42750, 20.43111] // Domaćinstvo Dragojlović (Bzovik)
    ]
  },
  {
    id: 8,
    name: "Bio jednom jedan (Mitovi i legende)",
    country: "serbia",
    color: "#2E7D32",
    staticMapUrl: "https://images.unsplash.com/photo-1687515513404-3646c8681874",
    coordinates: [
    [43.48417, 20.34111], // Vila Ivanović (Kumanica)
    [43.47167, 20.30139], // Hotel Golub (Odvraćenica)
    [43.47000, 20.30611], // Motel Kuč
    [43.47361, 20.29694], // Hotel Sedlo
    [43.33722, 20.27500] // Jankov Kamen (Vrh Golije)
    ]
  }];

  // Tourism offerings data from all 8 trails
  const tourismOfferings = [
  // Serbia - Život kroz vekove trail
  {
    id: 'tour_1',
    name: "Restoran Beli Bagrem",
    type: "restaurant",
    trailId: 5,
    country: "serbia",
    coordinates: [43.41444, 20.48444],
    description: "Tradicionalni restoran sa pogledom na planinu i domaćom kuhinjom.",
    contact: "+381 63 1611115",
    images: [{
      src: "https://img.rocket.new/generatedImages/rocket_gen_img_112504b1d-1763509274814.png",
      alt: "Restoran Beli Bagrem sa drvenom terasom i planinskim pogledom"
    }]
  },
  {
    id: 'tour_2',
    name: "Vila Jela",
    type: "accommodation",
    trailId: 5,
    country: "serbia",
    coordinates: [43.41583, 20.48250],
    description: "Smeštena na ivici livade, vila pruža savršen mir sa pogledom na Goliju.",
    contact: "+381 65 451 9912",
    email: "vilajela@gmail.com",
    images: [{
      src: "https://img.rocket.new/generatedImages/rocket_gen_img_1802ffca8-1763509274769.png",
      alt: "Vila Jela sa drvenom arhitekturom u planinskom okruženju"
    }]
  },
  {
    id: 'tour_3',
    name: "Orlovo gnezdo",
    type: "accommodation",
    trailId: 5,
    country: "serbia",
    coordinates: [43.41722, 20.48750],
    description: "Na litici iznad doline, savršeno mesto za parove i planinare.",
    contact: "+381 64 556 2228",
    email: "orlovognezdo.rudno@gmail.com",
    images: [{
      src: "https://images.unsplash.com/photo-1651076079183-384ddbcc52f9",
      alt: "Orlovo gnezdo smeštaj sa spektakularnim pogledom na dolinu"
    }]
  },
  {
    id: 'tour_4',
    name: "Bajkovito Selo",
    type: "accommodation",
    trailId: 5,
    country: "serbia",
    coordinates: [43.41389, 20.48278],
    description: "Tri drvene kućice skrivene među brežuljcima sa drvenim đakuzijem.",
    contact: "+381 63 1611115",
    images: [{
      src: "https://images.unsplash.com/photo-1672668899733-a9b5a9c92651",
      alt: "Bajkovito selo sa drvenim kućicama u prirodnom okruženju"
    }]
  },

  // Serbia - Osluškujući damare srednjovekovne Srbije trail
  {
    id: 'tour_5',
    name: "Restoran Studenica",
    type: "restaurant",
    trailId: 6,
    country: "serbia",
    coordinates: [43.48833, 20.52806],
    description: "Restoran u neposrednoj blizini manastira Studenica sa tradicionalnim jelima.",
    images: [{
      src: "https://images.unsplash.com/photo-1718939050529-1999dc8b3fba",
      alt: "Tradicionalni restoran sa kamenim elementima i rustičnom atmosferom"
    }]
  },
  {
    id: 'tour_6',
    name: "Hotel Radočelo",
    type: "accommodation",
    trailId: 6,
    country: "serbia",
    coordinates: [43.51833, 20.45833],
    description: "Planinski hotel sa pogledom na Radočelo i pristupom kulturnim spomenicima.",
    images: [{
      src: "https://images.unsplash.com/photo-1707051575537-7575736bf1ed",
      alt: "Planinski hotel sa modernim sadržajima u prirodnom okruženju"
    }]
  },

  // Montenegro - Od glečera do Grebaje trail
  {
    id: 'tour_7',
    name: "Restoran Ropojana",
    type: "restaurant",
    trailId: 1,
    country: "montenegro",
    coordinates: [42.50969, 19.83356],
    description: "Tradicionalni restoran u dolini Ropojane sa specijalitetima planinske kuhinje.",
    images: [{
      src: "https://images.unsplash.com/photo-1733976517246-ccb5e9284730",
      alt: "Planinski restoran sa kamenim zidovima i drvenim nameštajem"
    }]
  },
  {
    id: 'tour_8',
    name: "Vila Plavsko jezero",
    type: "accommodation",
    trailId: 1,
    country: "montenegro",
    coordinates: [42.59839, 19.93081],
    description: "Elegantna vila na obali Plavskog jezera sa nenadmašnim pogledom.",
    images: [{
      src: "https://images.unsplash.com/photo-1682964024268-8e73d2d133f1",
      alt: "Vila na obali jezera sa panoramskim pogledom na planine"
    }]
  },

  // Montenegro - Legende i priče iz srednjovjekovnog Brskova trail
  {
    id: 'tour_9',
    name: "Hotel Bjelasica",
    type: "accommodation",
    trailId: 2,
    country: "montenegro",
    coordinates: [42.89965, 19.59747],
    description: "Planinski hotel na padinama Bjelasice sa spa sadržajima.",
    images: [{
      src: "https://images.unsplash.com/photo-1707051575537-7575736bf1ed",
      alt: "Luksuzni planinski hotel sa velikim prozorim i terasama"
    }]
  },
  {
    id: 'tour_10',
    name: "Restoran Mojkovac",
    type: "restaurant",
    trailId: 2,
    country: "montenegro",
    coordinates: [42.95660, 19.57739],
    description: "Tradicionalni restoran u centru Mojkovca sa autentičnom atmosferom.",
    images: [{
      src: "https://img.rocket.new/generatedImages/rocket_gen_img_127e192bc-1763509273285.png",
      alt: "Restoran sa tradicionalnom crnogorskom arhitekturom"
    }]
  },

  // Montenegro - Kanjon Tare trail
  {
    id: 'tour_11',
    name: "Eco Resort Tara",
    type: "accommodation",
    trailId: 3,
    country: "montenegro",
    coordinates: [43.12778, 19.31182],
    description: "Eko kompleks na obali reke Tare sa aktivnostima na vodi.",
    images: [{
      src: "https://images.unsplash.com/photo-1657117697667-1a76f75d63a3",
      alt: "Eko resort sa drvenim bungalovima pored reke"
    }]
  },
  {
    id: 'tour_12',
    name: "Restoran Kanjon",
    type: "restaurant",
    trailId: 3,
    country: "montenegro",
    coordinates: [43.02782, 19.40083],
    description: "Restoran sa pogledom na kanjon Tare i specijalitetima rečne ribe.",
    images: [{
      src: "https://images.unsplash.com/photo-1596519919532-e68df412e210",
      alt: "Restoran sa panoramskim pogledom na kanjon i reku"
    }]
  },

  // Montenegro - U zagrljaju šume i tri jezera trail
  {
    id: 'tour_13',
    name: "Villa Durmitor",
    type: "accommodation",
    trailId: 4,
    country: "montenegro",
    coordinates: [43.15745, 19.09268],
    description: "Vila u srcu Durmitora sa pristupom svim trima jezerima.",
    images: [{
      src: "https://images.unsplash.com/photo-1640793036447-0792bc9128b3",
      alt: "Planinska vila okružena šumom sa pogledom na jezero"
    }]
  },
  {
    id: 'tour_14',
    name: "Restoran Tri Jezera",
    type: "restaurant",
    trailId: 4,
    country: "montenegro",
    coordinates: [43.15126, 19.10301],
    description: "Restoran sa specijalitetima divljači i pogledom na planinska jezera.",
    images: [{
      src: "https://images.unsplash.com/photo-1721115263588-07208de3ffc3",
      alt: "Planinski restoran sa kamenim delovima i pogledom na jezera"
    }]
  },

  // Serbia - I bi voda trail  
  {
    id: 'tour_15',
    name: "Pansion Nebo",
    type: "accommodation",
    trailId: 7,
    country: "serbia",
    coordinates: [43.40972, 20.45000],
    description: "Porodični pansion sa toplom atmosferom i domaćom kuhinjom.",
    contact: "+381 63 112 0405",
    images: [{
      src: "https://img.rocket.new/generatedImages/rocket_gen_img_10c285324-1763509274441.png",
      alt: "Pansion Nebo sa tradicionalnom arhitekturom"
    }]
  },
  {
    id: 'tour_16',
    name: "Vila Selena",
    type: "accommodation",
    trailId: 7,
    country: "serbia",
    coordinates: [43.41528, 20.48194],
    description: "Vila sa modernim sadržajima u mirnom planinskom okruženju.",
    images: [{
      src: "https://images.unsplash.com/photo-1724949286531-aad1be889342",
      alt: "Vila Selena sa elegantnim dizajnom i terasama"
    }]
  },

  // Serbia - Bio jednom jedan trail
  {
    id: 'tour_17',
    name: "Vila Ivanović",
    type: "accommodation",
    trailId: 8,
    country: "serbia",
    coordinates: [43.48417, 20.34111],
    description: "Vila u Kumanici sa autentičnom atmosferom i tradicionalnim gostoprimstvom.",
    images: [{
      src: "https://images.unsplash.com/photo-1591883093451-83abd0f56a1f",
      alt: "Tradicionalna vila sa kamenim elementima u planinskom selu"
    }]
  },
  {
    id: 'tour_18',
    name: "Hotel Golub",
    type: "accommodation",
    trailId: 8,
    country: "serbia",
    coordinates: [43.47167, 20.30139],
    description: "Hotel u Odvraćenici sa pogledom na vrhove Golije.",
    images: [{
      src: "https://images.unsplash.com/photo-1677777010379-36a65f9339a5",
      alt: "Planinski hotel sa panoramskim pogledom na vrhove"
    }]
  }];


  // Updated heritage sites data with 4 points for each country
  const heritageSites = [
  // Serbia Heritage Sites (4 points)
  {
    id: 1,
    name: "Studenica Monastery",
    type: "cultural",
    country: "serbia",
    coordinates: [43.4889, 20.5281],
    description: "A 12th-century Serbian Orthodox monastery and UNESCO World Heritage Site, renowned for its medieval frescoes and Byzantine architecture.",
    images: [
    {
      src: "https://images.unsplash.com/photo-1601575930200-8fb42cde2b39",
      alt: "Ancient stone monastery with white walls and red tile roof surrounded by green hills"
    },
    {
      src: "https://images.unsplash.com/photo-1507509021882-2ff2be560ed2",
      alt: "Interior view of monastery showing ornate Byzantine frescoes on arched walls"
    }],

    historicalPeriod: "12th Century",
    significance: "UNESCO World Heritage Site"
  },
  {
    id: 2,
    name: "Tara National Park",
    type: "natural",
    country: "serbia",
    coordinates: [43.9167, 19.4167],
    description: "A pristine national park featuring dense forests, deep river canyons, and diverse wildlife including brown bears and golden eagles.",
    images: [
    {
      src: "https://images.unsplash.com/photo-1516354841875-95f0cf7fb963",
      alt: "Dense green forest canopy with misty mountains in background during sunrise"
    },
    {
      src: "https://images.unsplash.com/photo-1693298667427-f456eab82746",
      alt: "Winding river cutting through deep forested canyon with steep rocky cliffs"
    }],

    area: "19,175 hectares",
    established: "1981"
  },
  {
    id: 5,
    name: "Novi Pazar Historic Center",
    type: "cultural",
    country: "serbia",
    coordinates: [43.1364, 20.5122],
    description: "A historic trading center showcasing Ottoman architecture, traditional crafts, and multicultural heritage at the crossroads of civilizations.",
    images: [
    {
      src: "https://images.unsplash.com/photo-1699990472557-77fe3329f809",
      alt: "Traditional Ottoman-style buildings with wooden balconies and stone foundations"
    },
    {
      src: "https://images.unsplash.com/photo-1660661143743-28e36380f29b",
      alt: "Bustling marketplace with colorful textiles and traditional crafts displayed"
    }],

    historicalPeriod: "Ottoman Period",
    significance: "Cultural Crossroads"
  },
  {
    id: 7,
    name: "Kopaonik National Park",
    type: "natural",
    country: "serbia",
    coordinates: [43.2981, 20.8176],
    description: "Serbia's largest mountain range featuring subalpine ecosystems, ski resorts, and diverse wildlife in a protected national park setting.",
    images: [
    {
      src: "https://images.unsplash.com/photo-1733547970721-d3786c8996ec",
      alt: "Snow-covered mountain peaks with ski slopes and alpine forest landscape"
    },
    {
      src: "https://images.unsplash.com/photo-1708966183599-a3a6cbee86fd",
      alt: "Mountain meadow with wildflowers and panoramic views of surrounding peaks"
    }],

    area: "11,810 hectares",
    established: "1981"
  },
  // Montenegro Heritage Sites (4 points)
  {
    id: 3,
    name: "Kotor Old Town",
    type: "cultural",
    country: "montenegro",
    coordinates: [42.4247, 18.7712],
    description: "A well-preserved medieval town with Venetian architecture, surrounded by impressive city walls and situated on the Bay of Kotor.",
    images: [
    {
      src: "https://images.unsplash.com/photo-1730664011373-3528d7c55d09",
      alt: "Medieval stone buildings with red tile roofs along waterfront with mountains behind"
    },
    {
      src: "https://images.unsplash.com/photo-1622524844257-95612790a176",
      alt: "Narrow cobblestone street between ancient stone walls with arched passages"
    }],

    historicalPeriod: "Medieval Period",
    significance: "UNESCO World Heritage Site"
  },
  {
    id: 4,
    name: "Durmitor National Park",
    type: "natural",
    country: "montenegro",
    coordinates: [43.1547, 19.0206],
    description: "A mountainous national park featuring glacial lakes, deep canyons, and the highest peaks in Montenegro, perfect for hiking and nature photography.",
    images: [
    {
      src: "https://images.unsplash.com/photo-1614037450502-f6f691d920af",
      alt: "Crystal clear mountain lake reflecting snow-capped peaks under blue sky"
    },
    {
      src: "https://images.unsplash.com/photo-1610140621520-0b5b72d7d1c9",
      alt: "Dramatic mountain peaks with jagged rocky formations against cloudy sky"
    }],

    area: "39,000 hectares",
    established: "1952"
  },
  {
    id: 6,
    name: "Biogradska Gora",
    type: "natural",
    country: "montenegro",
    coordinates: [42.9167, 19.6167],
    description: "One of Europe's last remaining primeval forests, featuring ancient trees, pristine lakes, and untouched wilderness ecosystems.",
    images: [
    {
      src: "https://images.unsplash.com/photo-1677140080236-10e1e96012dd",
      alt: "Ancient forest with massive tree trunks and dappled sunlight filtering through canopy"
    },
    {
      src: "https://images.unsplash.com/photo-1539104297257-765afa5db298",
      alt: "Serene forest lake surrounded by tall evergreen trees and mountain reflections"
    }],

    area: "5,650 hectares",
    established: "1952"
  },
  {
    id: 8,
    name: "Lovćen National Park",
    type: "cultural",
    country: "montenegro",
    coordinates: [42.4058, 18.8314],
    description: "A sacred mountain park featuring the mausoleum of Petar II Petrović-Njegoš and offering spectacular views over Montenegro and the Adriatic Sea.",
    images: [
    {
      src: "https://img.rocket.new/generatedImages/rocket_gen_img_146a2d3cc-1763463088424.png",
      alt: "Monumental mausoleum structure perched on mountain peak with panoramic views"
    },
    {
      src: "https://images.unsplash.com/photo-1671617276076-dad9cb1d6134",
      alt: "Winding mountain road through dramatic landscape with stone formations"
    }],

    area: "6,220 hectares",
    significance: "Cultural and Natural Monument"
  }];


  // Custom marker icons
  const createCustomIcon = (type) => {
    const iconConfig = {
      cultural: {
        html: `<div class="w-8 h-8 bg-accent rounded-full flex items-center justify-center shadow-lg border-2 border-white">
                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                   <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/>
                   <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/>
                   <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/>
                   <path d="M10 6h4"/>
                   <path d="M10 10h4"/>
                   <path d="M10 14h4"/>
                   <path d="M10 18h4"/>
                 </svg>
               </div>`,
        className: 'cultural-marker'
      },
      natural: {
        html: `<div class="w-8 h-8 bg-success rounded-full flex items-center justify-center shadow-lg border-2 border-white">
                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                   <path d="M12 2v20"/>
                   <path d="m15 5-3-3-3 3"/>
                   <path d="m9 9 3 3 3-3"/>
                   <path d="m15 13-3 3-3-3"/>
                   <path d="m15 17-3 3-3-3"/>
                 </svg>
               </div>`,
        className: 'natural-marker'
      },
      restaurant: {
        html: `<div class="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center shadow-lg border-2 border-white">
                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                   <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/>
                   <path d="M7 2v20"/>
                   <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Z"/>
                 </svg>
               </div>`,
        className: 'restaurant-marker'
      },
      accommodation: {
        html: `<div class="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center shadow-lg border-2 border-white">
                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                   <path d="M2 17h20v2H2z"/>
                   <path d="M13.4 14c-.8-.8-2-.8-2.8 0l-1.1 1.1c-.8.8-2 .8-2.8 0L5.6 14"/>
                   <path d="m8 11 2-2 2 2"/>
                   <path d="M2 9.5c0-.3.1-.6.3-.8l7.7-7.7c.4-.4 1-.4 1.4 0l7.7 7.7c.2.2.3.5.3.8v9.5"/>
                 </svg>
               </div>`,
        className: 'accommodation-marker'
      }
    };

    return L?.divIcon({
      html: iconConfig?.[type]?.html,
      className: iconConfig?.[type]?.className,
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32]
    });
  };

  // Initialize map
  useEffect(() => {
    if (!mapRef?.current || mapInstanceRef?.current) return;

    // Create map centered on the region with improved z-index handling
    const map = L?.map(mapRef?.current, {
      center: [43.0, 19.5],
      zoom: 7,
      zoomControl: false,
      attributionControl: false,
      zIndex: 1 // Set base z-index for map
    });

    // Add tile layer
    L?.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
      zIndex: 1
    })?.addTo(map);

    // Add custom zoom control with higher z-index
    L?.control?.zoom({
      position: 'bottomright'
    })?.addTo(map);

    mapInstanceRef.current = map;
    setIsMapLoaded(true);

    return () => {
      if (mapInstanceRef?.current) {
        mapInstanceRef?.current?.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  // Update markers and trail routes based on filters
  useEffect(() => {
    if (!mapInstanceRef?.current || !isMapLoaded) return;

    // Clear existing markers and trail lines
    markersRef?.current?.forEach((marker) => {
      mapInstanceRef?.current?.removeLayer(marker);
    });
    markersRef.current = [];

    trailLinesRef?.current?.forEach((line) => {
      mapInstanceRef?.current?.removeLayer(line);
    });
    trailLinesRef.current = [];

    // Add trail routes if enabled
    if (activeFilters?.trails) {
      const filteredTrails = thematicTrails?.filter((trail) => {
        if (activeFilters?.montenegroTrails && trail?.country === 'montenegro') return true;
        if (activeFilters?.serbiaTrails && trail?.country === 'serbia') return true;
        return false;
      });

      filteredTrails?.forEach((trail) => {
        // Create polyline for the trail
        const polyline = L?.polyline(trail?.coordinates, {
          color: trail?.color,
          weight: 4,
          opacity: 0.8,
          smoothFactor: 1
        })?.addTo(mapInstanceRef?.current);

        // Add click event for trail info popup
        polyline?.on('click', () => {
          const popup = L?.popup({
            maxWidth: 300,
            className: 'trail-popup'
          })?.
          setLatLng(trail?.coordinates?.[0])?.
          setContent(`
              <div class="p-3">
                <h3 class="font-semibold text-base mb-2">${trail?.name}</h3>
                <p class="text-sm text-gray-600 mb-3">
                  ${trail?.country === 'montenegro' ? 'Crna Gora' : 'Srbija'}
                </p>
                <button 
                  class="w-full bg-blue-600 text-white px-3 py-2 rounded text-sm hover:bg-blue-700 transition-colors"
                  onClick="window.open('/trail-details', '_blank')"
                >
                  Istraži stazu
                </button>
              </div>
            `)?.
          openOn(mapInstanceRef?.current);
        });

        trailLinesRef?.current?.push(polyline);
      });
    }

    // Filter sites based on active filters
    const filteredSites = heritageSites?.filter((site) => {
      if (activeFilters?.showAll) return true;
      if (activeFilters?.cultural && site?.type === 'cultural') return true;
      if (activeFilters?.natural && site?.type === 'natural') return true;
      return false;
    });

    // Add filtered heritage site markers
    filteredSites?.forEach((site) => {
      const marker = L?.marker(site?.coordinates, {
        icon: createCustomIcon(site?.type)
      })?.addTo(mapInstanceRef?.current);

      marker?.on('click', () => {
        onMarkerClick(site);
      });

      markersRef?.current?.push(marker);
    });

    // Add tourism offerings markers (restaurants and accommodations)
    if (activeFilters?.trails) {
      const filteredOfferings = tourismOfferings?.filter((offering) => {
        const trail = thematicTrails?.find((t) => t?.id === offering?.trailId);
        if (!trail) return false;
        if (activeFilters?.montenegroTrails && trail?.country === 'montenegro') return true;
        if (activeFilters?.serbiaTrails && trail?.country === 'serbia') return true;
        return false;
      });

      filteredOfferings?.forEach((offering) => {
        const marker = L?.marker(offering?.coordinates, {
          icon: createCustomIcon(offering?.type)
        })?.addTo(mapInstanceRef?.current);

        marker?.on('click', () => {
          onMarkerClick(offering);
        });

        markersRef?.current?.push(marker);
      });
    }
  }, [activeFilters, isMapLoaded, onMarkerClick]);

  return (
    <div className="relative w-full h-full bg-muted rounded-lg overflow-hidden" style={{ zIndex: 1 }}>
      <div
        ref={mapRef}
        className="w-full h-full"
        style={{ minHeight: '500px', zIndex: 1 }} />

      {!isMapLoaded &&
      <div className="absolute inset-0 flex items-center justify-center bg-muted" style={{ zIndex: 10 }}>
          <div className="flex flex-col items-center space-y-4">
            <div className="animate-spin">
              <Icon name="Loader2" size={32} className="text-primary" />
            </div>
            <p className="text-muted-foreground font-medium">Loading heritage map...</p>
          </div>
        </div>
      }

      {/* Enhanced Map Legend with improved z-index */}
      <div className="absolute bottom-4 left-4 bg-card rounded-lg shadow-lg p-4 max-w-xs" style={{ zIndex: 1000 }}>
        <h4 className="font-heading font-semibold text-sm mb-3">Map Legend</h4>
        <div className="space-y-3">
          {/* Heritage Sites */}
          <div>
            <h5 className="text-xs font-medium text-muted-foreground mb-2">Heritage Sites</h5>
            <div className="space-y-2">
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 bg-accent rounded-full flex items-center justify-center">
                  <Icon name="Building2" size={12} color="white" />
                </div>
                <span className="text-sm text-foreground">Cultural Heritage</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 bg-success rounded-full flex items-center justify-center">
                  <Icon name="Trees" size={12} color="white" />
                </div>
                <span className="text-sm text-foreground">Natural Heritage</span>
              </div>
            </div>
          </div>

          {/* Tourism Offerings */}
          <div className="border-t border-border pt-3">
            <h5 className="text-xs font-medium text-muted-foreground mb-2">Tourism Offerings</h5>
            <div className="space-y-2">
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center">
                  <Icon name="UtensilsCrossed" size={12} color="white" />
                </div>
                <span className="text-sm text-foreground">Restaurants</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                  <Icon name="Home" size={12} color="white" />
                </div>
                <span className="text-sm text-foreground">Accommodations</span>
              </div>
            </div>
          </div>

          {/* Trail Routes */}
          <div className="border-t border-border pt-3">
            <h5 className="text-xs font-medium text-muted-foreground mb-2">Thematic Trails</h5>
            <div className="space-y-2">
              <div className="flex items-center gap-3">
                <div className="w-4 h-1 rounded-full" style={{ backgroundColor: '#E67E22' }}></div>
                <span className="text-sm text-foreground">Montenegro Trails</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-4 h-1 rounded-full" style={{ backgroundColor: '#2E7D32' }}></div>
                <span className="text-sm text-foreground">Serbia Trails</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);

};

export default MapContainer;